import { Component, OnInit } from "@angular/core";
import { FormBuilder, Validators } from '@angular/forms';
import { ValidationService } from '../../../linknet-common/validators/index';
import { WebshopService } from '../../../linknet-common/restful-services/restful.service';
import { INgxMyDpOptions } from 'ngx-mydatepicker';
import { ToastrService } from "ngx-toastr";
import { GlobalService } from 'app/linknet-common/globals/global.service';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'shop-app-logo-compliment',
    templateUrl: './logo-compliment.component.html',
    styleUrls: ['./logo-compliment.component.scss'],
})

export class LogoComplimentComponent implements OnInit{
    public logoCompliment: any;
    public optionsSelectSalutation: Array<any>;
    public optionsSelectProduct: Array<any>;
    public optionsSelectLogo: Array<any>;
    public optionsSelectDelivery: Array<any>;
    public loaderShow: Boolean = false;
    public myOptions: INgxMyDpOptions = {
      dateFormat: 'dd-mm-yyyy',
    };
    webshop:any;
    customerID:any;
    constructor(public datePipe: DatePipe, private formBuilder: FormBuilder, private _httpWebshopService: WebshopService, private toastr: ToastrService,public globalService: GlobalService){
      const d: Date = new Date();
      this.myOptions = {
        dateFormat: 'dd-mm-yyyy',
        disableUntil: { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() - 1 }
      }
      this._httpWebshopService.getBannerMaster().subscribe((data: any)=>{
        this.optionsSelectProduct = [];
        this.optionsSelectLogo = [];
        this.optionsSelectDelivery = [];
        data.BannerProducts.forEach((element) => {
          const list = {
            value: element.ProductId,
            label: element.ProductName,
          };
          this.optionsSelectProduct.push(list);
        });
        data.LogoPrintTypes.forEach((element) => {
          const list = {
            value: element.PrintLogoId,
            label: element.Name,
          };
          this.optionsSelectLogo.push(list);
        });

        data.TargetAudiences.forEach((element) => {
          const list = {
            value: element.Id,
            label: element.CustomerType,
          };
          this.optionsSelectDelivery.push(list);
        });
      })

        this.optionsSelectSalutation = [
            {
              'value': 'CAPT',
              'label': 'CAPT'
            },
            {
              'value': 'DR',
              'label': 'DR'
            },
            {
              'value': 'MR',
              'label': 'MR'
            },
            {
              'value': 'MRS',
              'label': 'MRS'
            },
            {
              'value': 'MISS',
              'label': 'MISS'
            },
            {
              'value': 'MS',
              'label': 'MS'
            }
        ];
        this.webshop = JSON.parse(sessionStorage.getItem('webshopDetail'));
        this.customerID = this.webshop.CustomerID;

    }

    loadForm(){
      const userSettings = this.globalService.getLoggedInData();
      this.logoCompliment = this.formBuilder.group({
        'Salutation': [userSettings.Salutation, [Validators.required]],
        'FirstName': [userSettings.FirstName, [Validators.required]],
        'LastName': [userSettings.LastName, [Validators.required]],
        'CompanyName': [userSettings.CompanyName, [Validators.required]],
        'Email': [userSettings.Email, [Validators.required, ValidationService.emailValidator]],
        'Department': [userSettings.Department],
        'PhoneNumber': [userSettings.PhoneNumber, [Validators.required, Validators.maxLength(10)]],
        'Product1': [null, [Validators.required]],
        'Quantity1': ['', [Validators.required]],
        'Product2': [null],
        'Quantity2': [''],
        'Product3': [null],
        'Quantity3': [''],
        'Product4': [null],
        'Quantity4': [''],
        'Product5': [null],
        'Quantity5': [''],
        'LogoType': [null, [Validators.required]],
        'RequiredBy': ['', [Validators.required]],
        'DeliveryType': [null, [Validators.required]],
    });
    }

    ngOnInit() {
      this.loadForm();
    }

    onlyNumberKey(event) {
        const pattern = new RegExp('^[0-9\b]+$');
        const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
        if (!pattern.test(key) && event.charCode !== 0) {
          event.preventDefault();
          return false;
        }
    }

    proceed(){
      let board = JSON.parse(sessionStorage.getItem('billBoardList'));
      this.logoCompliment.value.RequiredBy = this.datePipe.transform(this.logoCompliment.value.RequiredBy.jsdate, 'dd/MM/yyyy');
      const params = {
        "Salutation": this.logoCompliment.value.Salutation,
        "FirstName": this.logoCompliment.value.FirstName,
        "LastName": this.logoCompliment.value.LastName,
        "CompanyName": this.logoCompliment.value.CompanyName,
        "Department": this.logoCompliment.value.Department,
        "CompanyEmail": this.logoCompliment.value.Email,
        "Mobile": this.logoCompliment.value.PhoneNumber,
        "Product1": this.logoCompliment.value.Product1,
        "Quantity1": parseInt(this.logoCompliment.value.Quantity1),
        "Product2": this.logoCompliment.value.Product2,
        "Quantity2": parseInt(this.logoCompliment.value.Quantity2),
        "Product3": this.logoCompliment.value.Product3,
        "Quantity3": parseInt(this.logoCompliment.value.Quantity3),
        "Product4": this.logoCompliment.value.Product4,
        "Quantity4": parseInt(this.logoCompliment.value.Quantity4),
        "Product5": this.logoCompliment.value.Product5,
        "Quantity5": parseInt(this.logoCompliment.value.Quantity5),
        "TypeofLogo": this.logoCompliment.value.LogoType,
        "RequiredBy": this.logoCompliment.value.RequiredBy,
        "DeliveryType": this.logoCompliment.value.DeliveryType,
        "DigitalProducts": null,
        "PhysicalProducts": null,
        "Merchandise_CompanyLogo": null,
        "WhiteLabelling_Program": null,
        "AnnualBudget": null,
        "Target_Audience": 0,
        "BrandName": null,
        "ModelNo": null,
        "Quantity": 0,
        "Target_Price": null,
        "BillBoardId": board[0].BillboardAdID,
        "BannerId":1,
        "CustomerId": this.customerID
      }
      this.loaderShow = true;
      this._httpWebshopService.createBanner(params).subscribe((_data)=>{
          this.loadForm();
          this.loaderShow = false;
          this.toastr.success('Enquiry submitted.')
      },_error=>{
        this.loaderShow = false;
        this.toastr.error('Please try again.')
      })
    }
}